import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    // theme: {
    //     themes: {
    //         light: {
    //             primary: '#607d8b',
    //             secondary: '#00bcd4',
    //             accent: '#795548',
    //             error: '#f44336',
    //             warning: '#ffc107',
    //             info: '#03a9f4',
    //             success: '#4caf50'
    //         }
    //     }
    // }
});
